import { createFileRoute } from "@tanstack/react-router";
import Cars from "@/pages/Cars";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/cars/")({
  head: () => routeHead("/de/cars/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Cars />
  );
}
